<template>
  <video 
    :aria-label="ariaLabel"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </video>
</template>

<script>
export default {
  name: "BaseVideo",
  inheritAttrs: false,
  props: {
    ariaLabel: { type: String, required: true },
    src: { type: String, required: false, default: null },
    loop: { type: Boolean, required: false, default: false },
    muted: { type: Boolean, required: false, default: false },
    poster: { type: String, required: false, default: "" },
  }
};
</script>
